var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.32 11h-.785l-.278-.27a6.532 6.532 0 001.47-5.34c-.467-2.78-2.771-5-5.552-5.34C3.974-.47.438 3.09.955 7.32c.337 2.8 2.542 5.12 5.303 5.59a6.426 6.426 0 005.304-1.48l.268.28v.79l4.22 4.25c.408.41 1.074.41 1.48 0 .408-.41.408-1.08 0-1.49L13.32 11zm-5.96 0c-2.473 0-4.469-2.01-4.469-4.5S4.887 2 7.361 2c2.473 0 4.469 2.01 4.469 4.5S9.834 11 7.36 11z"
  })));
}
export default SvgSearch;